/** Runs one operation per id at once and says which succeeded (P16-4 Ruling 4: partial failures are reported). */
export async function settle(ids: readonly string[], op: (id: string) => Promise<unknown>): Promise<{ done: string[]; failed: string[] }> {
  const results = await Promise.allSettled(ids.map((id) => op(id)));
  return {
    done: ids.filter((_, i) => results[i]!.status === 'fulfilled'),
    failed: ids.filter((_, i) => results[i]!.status === 'rejected'),
  };
}
